module.exports = __webpack_public_path__ + "static/media/goal_lost.85a832da.jpg";